export default "__VITE_ASSET__BQRJ5Wc5__"